<div
  [attr.aria-label]="content.switchingAccountText"
  class="fixed top-0 left-0 z-[10000] block w-full h-full overflow-hidden"
  id="switch-account-overlay"
>
  <div
    [ngStyle]="{ 'background-image': 'url(' + content.backgroundImage + ')' }"
    class="fixed z-[101] w-full h-full bg-cover"
  ></div>
  <div
    [attr.aria-label]="content.switchingAccountText"
    aria-live="assertive"
    class="fixed top-[10%] left-1/2 -translate-x-1/2 z-[1000001]"
  >
    <img class="siteLogo" src="{{ content.businessLogo }}" />
  </div>
  <div
    class="fixed top-[65%] left-1/2 -translate-x-1/2 z-[1000001] w-20 h-[100px]"
  >
    <img class="loadingLogo w-4/5" src="{{ content.progressImageUrl }}" />
  </div>
  <div
    class="fixed top-[80%] left-1/2 -translate-x-1/2 z-[1000001] px-5 text-inverse text-center w-[60%]"
  >
    <span
      class="text-label-lg-semibold font-thin laptop:text-label-xl-semibold"
      innerHTML="{{ content.switchingAccountText }}"
    ></span>
  </div>
</div>
